import React from 'react';
import {View} from 'MWC';
import mainTpl from '../templates/ut-card';
import {SECTION_TARIFFS} from '../constants';
import PropTypes from 'prop-types';
import UkrainiansTogetherCardsModel from '../models/ukrainiansTogether.m';
import {apiback} from '../../../config';
import widgetsHelper from 'utils/getWidget.helper';
import GreenCardsModel from '../../Cards/models/greenCards.m';

const greenCard = 'green_card';

class Main extends View {
    template = mainTpl;

    constructor(props) {
        super(props);

        this.tariffsElement = React.createRef();

        this.state = {
            ui: this.uiStates.INITIAL,
            model: {},
            isUtm: new URLSearchParams(this.props.location.search).get('utm_source'),
            mode: 'info',
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: [],
            loader: true
        };
        this.widgetsHelper = widgetsHelper;
    }

    componentWillMount() {
        fetch(apiback('CREDIT_CARDS'))
            .then(res => res.json())
            .then(json =>
                this.setState({
                    model: new UkrainiansTogetherCardsModel(json.data[greenCard])
                })
            );
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    }

    componentWillReady() {
        this.widgetsHelper.getWidgets.call(this);
    }

    componentReady() {
        const {section} = this.props.match?.params;

        if (section === SECTION_TARIFFS) {
            this.tariffsElement.current?.scrollIntoView({behavior: 'smooth'});
        }
    }
    toggleMode = mode => {
        this.setState({mode: mode});
    };

    static contextTypes = {
        app: PropTypes.object
    };

    static displayName = 'UkrainiansTogether.Views.Main';
}

export default Main;
